import React from "react";

import {View, Text, ScrollView, StyleSheet, TouchableOpacity, Image, Dimensions} from "react-native";

import Config from "../../Config";
import {RFValue} from "react-native-responsive-fontsize";
import { Ionicons} from "@expo/vector-icons";
import According from "../Components/According";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import Toast from "../Components/Toast";
import Loading from "../Components/Loading";




const Course =({navigation ,route})=>{

    let [data, setData] = React.useState(false);

    React.useEffect(() => {
        getData();
    },[route.params.course_id]);
    let getData = async ()=>{
        try {
            let token = await AsyncStorage.getItem('token');
            let res = await axios.get(`${Config.api}/user/lessons/${route.params.course_id}`,{ 'headers': {  Authorization: 'Bearer '+token} });
            if(res.data.code != 1){
                // alert(JSON.stringify(res.data));
                // console.log(res.data.data);
                Toast(res.data.error);
            }
            setData( res.data);
            console.log(data.courses.name);
        } catch (err) {
            console.log(err);
        }
    }

    const getBack = ()=>{
        if(route.params.back == 1){
            navigation.goBack();
        }
        else{
            navigation.navigate('CategoryGroup',{category_id : data.courses.category_id})
        }
    }

    return (
        <View style={styles.container}>
            {data ?
            <>
                <View style={styles.header}>
                    <TouchableOpacity  >
                        <Text style={styles.title}>
                            دوره
                            {` `}
                            {data.courses.name}
                        </Text>
                    </TouchableOpacity>

                    <View  style={{flex : 1}}>
                        <TouchableOpacity onPress={()=>{navigation.navigate('InfoCourse',{course_id:route.params.course_id})}}>
                            <Text style={styles.title2}>
                                جزئیات دوره
                            </Text>
                        </TouchableOpacity>
                    </View>




                    <TouchableOpacity onPress={getBack }>
                        <Ionicons style={styles.selficon} name="arrow-back" size={24} color="white" />
                    </TouchableOpacity>

                </View>
                <ScrollView style={{flex:1  , backgroundColor : '#6787F5'}}>

                    <View style={styles.content}>
                        {data.list.map( (item,index) =>
                            <According navigation={navigation} key={index} data={item} />
                        )}
                    </View>
                </ScrollView>
            </>
            :
                <Loading/>
            }



        </View>
    );
}

const styles = StyleSheet.create({

    content : {
        flex: 1,
        paddingHorizontal: RFValue(20),
        justifyContent: "center",
        paddingVertical: RFValue(20),
        backgroundColor : '#6787F5',
    },

    container : {
        flex: 1,
        backgroundColor: '#FAFAFA',
    },
    header: {
        flexDirection : 'row',
        justifyContent : 'flex-start',
        alignItems : 'center',

        backgroundColor: '#000422',
        paddingHorizontal: RFValue(20),

        shadowColor:"#000000",
        shadowOffset: {
            width: 0,
            height: 50,
        },
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1
    },


    title : {
        fontSize: RFValue(14),
        fontFamily : 'ykb',
        color: Config.secondcolor,
        borderBottomColor : Config.secondcolor,
        borderBottomWidth : RFValue(3),
        paddingVertical: RFValue(14),
        minWidth : RFValue(80),


    },
    title2 : {
        fontSize: RFValue(14),
        fontFamily : 'yk',
        color: '#B2B4C4',
        marginRight: RFValue(20),

        borderBottomWidth : 1,
        paddingVertical: RFValue(14),
    }

})


export default Course